import { AfterViewInit, Component, ElementRef, EventEmitter, inject, Input, Output, ViewChild } from '@angular/core';
import { faQuestion } from '@fortawesome/free-solid-svg-icons';
import { SubAccountDetails } from '../sms-call';
import { SmsCallService } from '../sms-call.service';
import { AlertService } from '@main/alert.service';
import Stepper from 'bs-stepper';
import { NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { A2PRegistrationBusinessInformation } from '../a2p-registration-business-information/a2p-registration-business-information.component';
import { A2PRegistrationAuthorizedRepresentative } from '../a2p-registration-authorized-representative/a2p-registration-authorized-representative.component';
import { A2PRegistrationBusinessAddressComponent } from '../a2p-registration-business-address/a2p-registration-business-address.component';
import { NgTemplateOutlet } from '@angular/common';

@Component({
  selector: 'app-settings-communications-registration',
  imports: [A2PRegistrationBusinessInformation, A2PRegistrationAuthorizedRepresentative, A2PRegistrationBusinessAddressComponent, NgTemplateOutlet, NgbPopoverModule, FaIconComponent],
  templateUrl: './settings-communications-registration.component.html',
  styleUrl: './settings-communications-registration.component.css'
})
export class SettingsCommunicationsRegistrationComponent implements AfterViewInit {

  // Properties
  @ViewChild('a2pRegistrationStepperRef') private a2pRegistrationStepperRef: ElementRef;
  @Input() subAccountDetails: SubAccountDetails;
  @Output() refreshSubaccountDetails: EventEmitter<void> = new EventEmitter<void>();

  private a2pRegistrationStepper: Stepper;

  // Font Awesome Properties
  faQuestion = faQuestion;

  // Injections
  private smsCallService = inject(SmsCallService);
  private alertService = inject(AlertService);

  ngAfterViewInit(): void {
    if (this.subAccountDetails?.subaccount) {
      this.initializeStepper();
    }
  }

  // Initialize Stepper
  private initializeStepper() {
    this.a2pRegistrationStepper = new Stepper(this.a2pRegistrationStepperRef.nativeElement, {
      linear: false,
      animation: true
    });
    this.checkFormStep();
  }

  // Check Form Step
  private checkFormStep() {
    if (this.subAccountDetails?.customerProfile?.businessAddress) {
      this.a2pRegistrationStepper.to(4);
      return;
    }
    if (this.subAccountDetails?.customerProfile?.authorizedRepresentative) {
      this.a2pRegistrationStepper.to(3);
      return;
    }
    if (this.subAccountDetails?.customerProfile?.businessInformation) {
      this.a2pRegistrationStepper.to(2);
      return;
    }
    this.a2pRegistrationStepper.to(1);
  }

  // Next Step
  nextStep(): void {
    this.a2pRegistrationStepper.next();
    this.refreshSubaccountDetails.emit();
  }

  // Submit For Review
  submitForReview(): void {
    this.smsCallService.evaluateAndSubmit().subscribe(() => {
      this.alertService.showSuccessAlert('Application Submitted');
      this.refreshSubaccountDetails.emit();
    });
  }
}
